export default function (data) {
  let self = this;
  self.$el = $('#emailprefs');
  self.email_preference = ko.observable();
  self.marketing_groups = ko.observableArray([]);
  self.global_unsubscribed = ko.observable(false);

  self.bindData = function(data) {
    self.email_preference(ko.mapping.fromJS(data.email_preference));
    self.marketing_groups(ko.mapping.fromJS(data.marketing_subscribe_groups)());
    self.global_unsubscribed(self.email_preference().unsubscribed());

    self.global_unsubscribed.subscribe(self.save);
    self.email_preference().marketing_email_subscribe_group_ids.subscribe(self.save, null, 'arrayChange');
    _.each(self.email_preference().settings, function(item, idx) {
      item.subscribe(self.save);
    });
  };

  self.save = function(item, event) {
    let data = {email_preference: ko.mapping.toJS(self.email_preference)};
    let request = new Kadenze.AjaxRequest({
      type: 'PATCH',
      url: Kadenze.Routes.email_preferences_path(),
      data: data,
      loadingIndicator: {
        container: self.$el
      }
    });

    request.done(function(response) {
      new Kadenze.Notice.success({ message: Kadenze.I18n.t('dict.save_success') });
    });

    request.fail(function(xhr, status, msg) {
      Kadenze.UIUtil.showNotice(self.$el, xhr.responseJSON, 3000);
    });

    return request;
  };

  const __construct = function(that) {
    console.log('constructor called for EmailPreferencesVM');
    that.bindData(data);

    self.email_preference().unsubscribed.subscribe(function(newVal) {
      self.global_unsubscribed(newVal);
    });
  }(this);
}
